/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBadgeOff = createReactComponent("badge-off", "IconBadgeOff", [
  ["path", { d: "M7 7v10l5 3l5 -3m0 -4v-9l-5 3l-2.496 -1.497", key: "svg-0" }],
  ["path", { d: "M3 3l18 18", key: "svg-1" }]
]);

export { IconBadgeOff as default };
//# sourceMappingURL=IconBadgeOff.js.map
